// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"title-and-variant_titleWrapper__64q2M","productTitle":"title-and-variant_productTitle__UoSZp","variantName":"title-and-variant_variantName__D_ZV7"};